<template>
  <v-chip
    small
    outlined
    class="chip-text-primary"
    @click="$emit('input', !value)"
  >
    <v-icon
      class="mr-2"
      :class="{
        'rotate-180': value
      }"
    >
      expand_more
    </v-icon>
    {{ $t('article.tips.label') }}
  </v-chip>
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        name: "ArticlePartTipToggle",
        props: {
            value: {
                type: Boolean,
                default: false
            }
        },
    });
</script>


<style scoped lang="sass">
</style>
